import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toDate, toEuros, estEnCoursDeChargement } from '../../App_Code/Utils';
import { exerciceCourant } from '../../App_Code/ExeComptable';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Card from '../Card';

const LigneNombre = ({
    titre, dateTitre, valeur, derniereLigne,
}) => (
    <div className={`row ${derniereLigne ? 'mb-0' : 'mb-2'}`}>
        <span className="col-8 text-secondary">{`${titre} ${dateTitre ? toDate(dateTitre, 'L') : ''}`}</span>
        <span className={`text-right col-4 ${valeur < 0 ? 'text-danger' : ''}`}>{`${toEuros(valeur, true)} €`}</span>
    </div>
);

const CardComptabilite = ({
    LsExercices, Proprietaires, Banques, Charges, EstMembreCS, BalanceCpt_Visible, ComptaEnReprise_Visible, EtatGestion
}) => {
    if (estEnCoursDeChargement(Proprietaires) || estEnCoursDeChargement(Banques) || estEnCoursDeChargement(Charges)) {
        return <Chargement titreCard="Comptabilité" />;
    }

    let soldePro = 0;
    Proprietaires.forEach((proprio) => {
        soldePro += proprio.Cpt.Solde;
    });
    const Banque = Banques.find(banque => banque.Compte && banque.Compte.Code === 'BNQ');
    const ExeCourant = exerciceCourant(LsExercices);
    const DateDebExeCourant = ExeCourant ? new Date(ExeCourant.DateDeb) : null;
    const DateFinExeCourant = ExeCourant ? new Date(ExeCourant.DateFin) : null;
    const DateDebExeFutur = ExeCourant ? new Date(DateFinExeCourant) : null;
    if (ExeCourant) DateDebExeFutur.setDate(DateFinExeCourant.getDate() + 1);
    const MasquerDebitPlus =
        DateDebExeFutur && DateDebExeFutur.getTime() > new Date().getTime() && Charges.DebitPlus === 0;

    return (
        <Card
            Titre={CardComptabilite.titleName}
            SousTitre={
                DateDebExeCourant && DateFinExeCourant
                    ? `Exercice du ${toDate(DateDebExeCourant, 'L')} au ${toDate(DateFinExeCourant, 'L')}`
                    : undefined
            }
        >
        { ((ComptaEnReprise_Visible==0 && EtatGestion==1) || (ComptaEnReprise_Visible==2 && EtatGestion==1 && !EstMembreCS )) ?
            <React.Fragment>
                <div className="card-text mb-3">
                        <p style={{fontSize:"14px",fontWeight:"bold",padding:"20px 0 20px 20px"}}>Reprise comptable en cours.
                        <br/>L'accès aux informations est momentanément suspendu.</p>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div className="card-text mb-0">
                    <LigneNombre titre="Budget" dateTitre={DateDebExeCourant} valeur={Charges.Credit} />
                    <LigneNombre titre="Dépenses" dateTitre={DateDebExeCourant} valeur={Charges.Debit} />
                    {!MasquerDebitPlus && (
                        <LigneNombre titre="Dépenses" dateTitre={DateDebExeFutur} valeur={Charges.DebitPlus} />
                    )}
                    <LigneNombre titre="Solde propriétaires" valeur={soldePro} />
                    {Banque &&
                        Banque.Compte && (
                        <LigneNombre
                            titre="Solde banque au"
                            dateTitre={new Date()}
                            valeur={Banque.Compte.Solde}
                            derniereLigne
                        />
                    )}
                </div>
                <Link to="/MaCopropriete/Depenses" className="btn btn-outline-primary mt-3 mr-3">
                    Voir les dépenses
                </Link>
                <Link to="/MaCopropriete/Proprietaires" className="btn btn-outline-primary mt-3">
                    Voir les propriétaires
                </Link>
                { EstMembreCS && BalanceCpt_Visible ? 
                    <Link to="/MaCopropriete/Balance" className="btn btn-outline-primary mt-3">
                        <span className="badge badge-pill badge-cs mr-1" title="Vous avez accès à cette section car vous êtes membre du conseil syndical">
                            CS
                        </span>
                        Voir la balance
                    </Link> : 
                null }
                </React.Fragment> 
            }
        </Card>
    );
};
CardComptabilite.displayName = 'CardComptabilite';
CardComptabilite.titleName = 'Comptabilité';
CardComptabilite.requiredProps = [
    'LsExercices', // Liste des exercices comptables
    'Proprietaires', // Liste des propriétaires
    'Banques', // Liste des banques
    'Charges', // Liste des charges
    'EstMembreCS', // Bool si pro est membre CS
    'BalanceCpt_Visible', // Bool si l'agence autorise la vision balance au CS
];

function mapStateToProps({
    CopStore: {
        Cop: { 
            EtatGestion, 
            LsExercices, 
        },
        Proprietaires,
        Banques,
        Charges,
        
    },
    AdhStore: { EstMembreCS },
    SynStore: {
        Syn : { 
            BalanceCpt_Visible,
            ComptaEnReprise_Visible,
         },
    }
}) {
    return {
        LsExercices,
        Proprietaires,
        Banques,
        Charges,
        EtatGestion,
        EstMembreCS,
        BalanceCpt_Visible,
        ComptaEnReprise_Visible,
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardComptabilite));



// WEBPACK FOOTER //
// ./src/components/MaCopro/CardComptabilite.js